export default "__VITE_ASSET__YRBvHfMJ__"